window.axios = require("axios")
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest"

let token = document.head.querySelector('meta[name="csrf-token"]')

Array.prototype.swapItems = function(a, b) {
  this[a] = this.splice(b, 1, this[a])[0]
  return this
}

if (token) {
  window.axios.defaults.headers.common["X-CSRF-TOKEN"] = token.content
} else {
  console.error("CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token")
}
